'use strict';

module.exports = require('./components/TinyMCE');